import { PDFDownloadLink } from "@react-pdf/renderer";
import classNames from "classnames";
import { useEffect } from "react";
import PDFDocument from "shared/components/exportPDF";
import styles from "./style.module.scss";
import GlobalWrapper from "shared/components/common/globalWrapper";

interface OptionsDropDownProps {
  id?: string;
  open: boolean;
  setOpen: (val: boolean) => void;
  options: OptionProps[];
  customContainer: any;
  data?: any;
}

const DownlaodOptionsDropDown = ({
  open,
  id,
  setOpen,
  options,
  customContainer,
  data,
}: Partial<OptionsDropDownProps>) => {
  function handleClick(e: any) {
    const elem: any = document.getElementById(
      id ? id : "download-options-Container"
    );
    if (elem) {
      if (!elem?.contains(e.target)) {
        setOpen?.(false);
      }
    }
  }

  useEffect(() => {
    document.body.addEventListener(
      "click",
      (event: any) => {
        handleClick(event);
      },
      true
    );

    return () => {
      document.body.removeEventListener(
        "click",
        (event: any) => {
          handleClick(event);
        },
        true
      );
    };
    // eslint-disable-next-line
  }, []);

  return (
    <GlobalWrapper>
      <div
        className={classNames(
          styles.optionsContainer,
          customContainer && customContainer
        )}
        id={id ? id : "download-options-Container"}
        style={!open ? { visibility: "hidden" } : { visibility: "visible" }}
      >
        {options?.map(
          (
            Item: {
              title: string;
              Icon: any;
              action: (arg: any) => any;
            },
            inx: number
          ) => {
            return inx === 0 ? (
              <PDFDownloadLink
                onClick={() => {
                  setOpen?.(false);
                }}
                document={<PDFDocument data={data} />}
                fileName="report.pdf"
                key={inx}
              >
                <div
                  className={classNames(
                    "flex items-center gap-2 py-4 px-3",
                    styles.optionContainer,
                    inx === options?.length - 1 && styles.btmradius,
                    inx === 0 && styles.topradius
                  )}
                  style={
                    inx === options?.length - 1 ? { borderBottom: "0px" } : {}
                  }
                >
                  {Item?.Icon ? (
                    <Item.Icon className={classNames(styles.iconStyle)} />
                  ) : null}
                  <label
                    className={classNames(styles.labelStyle)}
                    role="button"
                  >
                    {Item?.title}
                  </label>
                </div>
              </PDFDownloadLink>
            ) : (
              <div
                className={classNames(
                  "flex items-center gap-2 py-4 px-3",
                  styles.optionContainer,
                  inx === options?.length - 1 && styles.btmradius,
                  inx === 0 && styles.topradius
                )}
                style={
                  inx === options?.length - 1 ? { borderBottom: "0px" } : {}
                }
                onClick={() => {
                  Item.action(data);
                  setOpen?.(false);
                }}
                key={inx}
                role="button"
              >
                {Item?.Icon ? (
                  <Item.Icon className={classNames(styles.iconStyle)} />
                ) : null}
                <label className={classNames(styles.labelStyle)} role="button">
                  {Item?.title}
                </label>
              </div>
            );
          }
        )}
      </div>
    </GlobalWrapper>
  );
};

export default DownlaodOptionsDropDown;
